module.exports = __webpack_public_path__ + "static/media/icon-audio-2.e7ca226e.svg";